module.exports = __webpack_public_path__ + "img/logo_baklavaspace.a91c8cac.png";